export enum ERoutingPreviousPage {
  BOOKING_CONFIRMATION_PAGE = 'BOOKING_CONFIRMATION_PAGE',
  BASKET_PAGE = 'BASKET_PAGE',
}
